module.exports = __webpack_public_path__ + "assets/img/nature-time-bg-7.73001ec3.png";